export class CredenciaisDTO {
    public email = '';
    public senha = '';
}